import React, { useState } from "react";
import Footer from "../components/Footer";
import { Subtitle } from "../components/shared/Subtitle";
import { Title } from "../components/shared/Title";
import { styled } from "styled-components";
import { PrimaryButton } from "../components/shared/Button";
import { scrollToSection } from "../components/shared/utils";
import { theme } from "../theme";
import emailjs from "@emailjs/browser";
import { Link } from "react-router-dom";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import PaymentsIcon from "@mui/icons-material/Payments";
import VideocamIcon from "@mui/icons-material/Videocam";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import PlayArrowIcon from "@mui/icons-material/PlayArrowOutlined";

import {
  FormControlLabel,
  TextField,
  Checkbox,
  Grid,
  CircularProgress,
} from "@mui/material";
import { ListItem } from "../components/shared/ListItem";

const Wrapper = styled.div`
  margin: 0 auto;
  max-width: 1000px;
  padding: 70px 5%;
`;

const DiscoverWrapper = styled.div`
  background-image: url("img/bg-main-page.png");
  background-size: cover;
  background-position: right bottom;
  background-repeat: no-repeat;
  padding: 20px 0px 40px;
  display: flex;
  justify-content: center;
`;

const DiscoverContentWrapper = styled.div`
  max-width: 850px;
  padding: 0 5%;
`;

const FormStyled = styled.form`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const GreyBg = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  margin: 0 auto;
`;

const Links = styled.span(
  ({ theme }) => `
  & a {
    color: ${theme.colors.blue}
  }  
  `
);

const ListStyled = styled.ul(
  ({ theme }) => `
  margin-right: 50px;
  list-style: none;
  padding-left: 0;

  & li {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
  }

  & svg {
    margin-right: 10px;
    color: ${theme.colors.blue}
  }
`
);

const DatesContent = styled.div`
  padding: 20px 20px 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const IconGroup = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 4px 0;
  font-weight: 600;

  & svg {
    margin-right: 10px;
    color: ${({ theme }) => theme.colors.orange};
  }
`;

const Content = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: 1fr;
  gap: 50px;
  text-align: left;

  & img {
    width: 100%;
    height: 300px;
    object-fit: cover;
    object-position: 50% 40%;
    border-radius: 8px;
  }

  & img,
  div {
    max-width: 768px;
    margin: auto;
  }

  @media (min-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
    & img {
      height: auto;
    }
  }
`;

const SubtitleAcademicP = styled(Subtitle)`
  text-align: left;
  margin: 0 0 30px 24px;
`;

const CTA = styled.div`
  width: 300px;
  margin: auto;
  & p {
    text-align: center;
    margin: 30px 0;
  }
  & button {
    display: block;
    margin: 0 auto;
  }
`;

const ContainerButton = styled.div`
  margin-top: 25px;
  width: 100%;
`;

const TeacherInfo = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;

  & .teacherText {
    display: flex;
    flex-direction: column;
    justify-content: center;

    & p {
      margin: 0;
    }

    & a {
      text-decoration: none;
    }
  }
`;

const TeachersGrid = styled.div`
  display: grid;
  gap: 30px;
  width: 100%;
  grid-template-columns: 1fr;

  @media (min-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
    justify-items: center;
    align-items: center;
    & img {
      height: auto;
    }
  }
`;

const TeacherWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  max-width: 400px;
  margin: auto;
`;

const LinkedInWrapper = styled.div`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.blue};
  gap: 5px;
`;

const ParagraphStyled = styled.p`
  font-size: 300;
  font-size: 14px;
`;

const textFieldStyles = {
  borderRadius: "5px",
  backgroundColor: "#EFEFEF",
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#EFEFEF",
    },
    "&:hover fieldset": {
      borderColor: theme.colors.blue,
    },
    "&.Mui-focused fieldset": {
      borderColor: theme.colors.blue,
    },
  },
  "& .MuiInputLabel-root": {
    color: "gray",
  },
  "& .MuiInputLabel-root.Mui-focused": {
    color: theme.colors.blue,
  },
  "& .MuiOutlinedInput-notchedOutline": {
    border: "none",
  },
};

export const Webinar = () => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [country, setCountry] = useState("");
  const [checked, setChecked] = useState(false);
  const [formState, setFormState] = useState({
    submitting: false,
    success: false,
    error: false,
  });
  const [errors, setErrors] = useState({});

  const handleChange = (event) => {
    setChecked(event.target.checked);
  };

  const validate = () => {
    const newErrors = {};
    if (!firstName)
      newErrors.firstName = "¿Cómo te llaman cuando te regañan? Eso va aquí.";
    if (!lastName) newErrors.lastName = "Porfa, somos curiosos.";
    if (!email) newErrors.email = "No usamos lechuzas, necesitamos tu correo.";
    if (!checked)
      newErrors.checked =
        "Solo falta aceptar esto y tu viaje puede comenzar 🚀";
    return newErrors;
  };

  const sendEmail = (e) => {
    e.preventDefault();
    const validationErrors = validate();
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length > 0) {
      return; // No envía si hay errores
    }

    setFormState((prevState) => ({ ...prevState, submitting: true }));

    const emailOptions = {
      email,
      first_name: firstName,
      country,
    };
    emailjs
      .send("service_584kxr8", "template_etoz646", emailOptions, {
        publicKey: "ATnw2CyneX_JxCF6q",
      })
      .then(
        () => {
          setFormState((prevState) => ({
            ...prevState,
            submitting: false,
            success: true,
          }));
        },
        (error) => {
          setFormState((prevState) => ({
            ...prevState,
            submitting: false,
            error: true,
          }));
        }
      );
  };

  const handleRetry = () => {
    setFormState({
      submitting: false,
      success: false,
      error: false,
    });
    setErrors({});
  };

  return (
    <>
      <DiscoverWrapper>
        <DiscoverContentWrapper>
          <Subtitle>
            ¿Quieres entrar en el mundo de IT y no sabes por dónde empezar?{" "}
          </Subtitle>
          <Title>Descubre cómo llegar a ser desarrollador web</Title>
          <Content>
            <div>
              <p>
                Aprende en qué consiste el trabajo de un{" "}
                <b>desarrollador web</b>, qué tecnologías se utilizan y cómo te
                guiamos paso a paso para que seas capaz de{" "}
                <b>desarrollar aplicaciones web desde cero</b>.
              </p>
              <DatesContent>
                <IconGroup>
                  <CalendarMonthIcon /> Miércoles, 26 de noviembre
                </IconGroup>
                <IconGroup>
                  <AccessTimeIcon /> 19:00h (España peninsular)
                </IconGroup>
                <IconGroup>
                  <VideocamIcon /> Online
                </IconGroup>
                <IconGroup>
                  <PaymentsIcon /> Gratis
                </IconGroup>
              </DatesContent>
              <CTA style={{ marginTop: "30px" }}>
                <PrimaryButton onClick={() => scrollToSection("register")}>
                  Reserva tu plaza
                </PrimaryButton>
              </CTA>
            </div>
            <img src="/img/frontend-dev.jpg" />
          </Content>
        </DiscoverContentWrapper>
      </DiscoverWrapper>

      <Wrapper>
        <h2 id="register">Reserva tu plaza ahora</h2>
        <p>Completa el formulario y te enviaremos el enlace al webinar.</p>
        {formState.submitting && <CircularProgress />}
        {formState.success ? (
          <div style={{ marginTop: 40, textAlign: "center" }}>
            <p style={{ color: theme.blue, fontSize: 20 }}>
              ✅ ¡Gracias! ¡Tu plaza esta reservada, revisa tu correo!
            </p>
          </div>
        ) : formState.error ? (
          <div style={{ marginTop: 40, textAlign: "center" }}>
            <p style={{ color: "red", fontSize: 18 }}>
              Houston, tenemos un problema... 👩‍🚀
            </p>
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                handleRetry();
              }}
              style={{
                color: theme.colors.blue,
                textDecoration: "underline",
                cursor: "pointer",
                fontWeight: 500,
                display: "inline-block",
                marginTop: 16,
              }}
            >
              Reintentar
            </a>
          </div>
        ) : (
          <FormStyled>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                  required
                  label="Nombre"
                  variant="outlined"
                  sx={textFieldStyles}
                  error={!!errors.firstName}
                  helperText={errors.firstName}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                  required
                  label="Apellido"
                  variant="outlined"
                  sx={textFieldStyles}
                  error={!!errors.lastName}
                  helperText={errors.lastName}
                />
              </Grid>
              <Grid item xs={12} md={12}>
                <TextField
                  fullWidth
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  label="Correo"
                  variant="outlined"
                  sx={textFieldStyles}
                  error={!!errors.email}
                  helperText={errors.email}
                />
              </Grid>
            </Grid>
            <FormControlLabel
              style={{ marginTop: 30 }}
              control={
                <Checkbox
                  checked={checked}
                  onChange={handleChange}
                  sx={{
                    color: theme.colors.blue,
                    "&.Mui-checked": {
                      color: theme.colors.blue,
                    },
                  }}
                />
              }
              label={
                <Links>
                  Acepto la{" "}
                  <Link to="/privacy-policy" target="_blank">
                    Política de Privacidad
                  </Link>{" "}
                  y los{" "}
                  <Link to="/terms-and-conditions" target="_blank">
                    Términos de Uso
                  </Link>
                  .
                  {errors.checked && (
                    <div
                      style={{ color: "#d32f2f", fontSize: 12, marginTop: 4 }}
                    >
                      {errors.checked}
                    </div>
                  )}
                </Links>
              }
              slotProps={{
                typography: { sx: { marginLeft: "10px", textAlign: "left" } },
              }}
            />
            <ContainerButton>
              <PrimaryButton $large onClick={sendEmail}>
                Reservar
              </PrimaryButton>
            </ContainerButton>
          </FormStyled>
        )}
      </Wrapper>

      <GreyBg>
        <Wrapper>
          <div style={{ marginTop: "30px" }}>
            <SubtitleAcademicP color="blue">
              ¿Qué vas a aprender en este webinar?
            </SubtitleAcademicP>
            <ListItem title="Qué implica trabajar como desarrollador frontend (web)">
              Vas a aprender qué puede hacer un desarrollador web y qué
              tecnologías usa.
            </ListItem>
            <ListItem title="Mercado laboral y beneficios">
              Vas a conocer en detalle cómo funciona el sector IT, qué
              oportunidades laborales surgen como desarrollador frontend (web) y
              cuales son los beneficios de trabajar en IT.
            </ListItem>
            <ListItem title="Presentación del bootcamp">
              Te vamos a contar qué tecnologías y habilidades vas a aprender en
              este bootcamp, qué metodología usamos y qué deberías esperar de
              nosotros.
            </ListItem>
            <ListItem title="Quiénes somos">
              Nos queremos presentar y mostrarte cómo te vamos a acompañar
              durante estos meses, cuál ha sido nuestro recorrido laboral y por
              qué decidimos empezar esta aventura.
            </ListItem>
          </div>
        </Wrapper>
      </GreyBg>

      <Wrapper>
        <div style={{ marginTop: "30px" }}>
          <SubtitleAcademicP color="orange">
            Esto es para ti si:
          </SubtitleAcademicP>
          <ListStyled>
            <li>
              <PlayArrowIcon />
              <span>
                Quieres darle un <b>giro a tu carrera</b> y entrar en el mundo
                de IT
              </span>
            </li>
            <li>
              <PlayArrowIcon />
              <span>
                Te dedicas a labores digitales (marketing, diseño, etc) y
                quieres
                <b> dar el salto a la programación</b>
              </span>
            </li>
            <li>
              <PlayArrowIcon />
              <span>
                Ya estás en el mundo de IT (trabajando como QA/PM etc) y quieres
                <b> empezar a escribir código</b>
              </span>
            </li>
            <li>
              <PlayArrowIcon />
              <span>
                Te <b>apasiona el desarrollo de software</b> y la creación de
                aplicaciones web
              </span>
            </li>
            <li>
              <PlayArrowIcon />
              <span>
                Estudiaste una carrera relacionada con el desarrollo web pero
                sientes que <b>no estás preparado/a</b> para trabajar en el
                sector
              </span>
            </li>
            <li>
              <PlayArrowIcon />
              <span>
                Viste varios vídeos en plataformas de aprendizaje en línea y
                sientes que <b>no aprendiste nada</b>
              </span>
            </li>
          </ListStyled>
          <CTA style={{ marginTop: "30px" }}>
            <PrimaryButton onClick={() => scrollToSection("register")}>
              Reserva tu plaza
            </PrimaryButton>
          </CTA>
        </div>
      </Wrapper>
      <GreyBg>
        <Wrapper>
          <TeachersGrid>
            <div>
              <h2>Conoce a los profesores</h2>
              <p>
                Somos <b>profesionales en activo</b>. Sabemos cómo funciona el
                mercado, cómo se trabaja en un entorno laboral real y qué es lo
                que te van a preguntar en entrevistas de trabajo.{" "}
              </p>
              <p>
                Pero lo más importante:{" "}
                <b>nos acordamos de cómo fueron nuestros inicios</b>, de todos
                los desafíos por los que pasamos ya que no nos enseñaron lo
                suficiente en los estudios que cursamos.
              </p>
              <p>
                Ahora sabemos lo que nos hubiese gustado saber al principio.
                Desde habilidades tecnológicas, el enfoque para afrontar retos
                diarios, hasta aspectos sumamente importantes para alcanzar el
                éxito como es la habilidad para trabajar en equipo y{" "}
                <b>metodologías ágiles</b>.
              </p>
              <p>
                Nuestro objetivo es darte a ti todo el conocimiento que nos
                faltó a nosotros al principio, el que llegamos a tener solo
                después de entrar en el mundo laboral. Queremos ahorrarte las
                frustraciones que nosotros sufrimos y{" "}
                <b>ahorrarte mucho tiempo y esfuerzo</b> para que alcances el
                éxito mucho más rápido.
              </p>
            </div>
            <TeacherWrapper>
              <TeacherInfo>
                <img src="/img/roxana.png" />
                <div className="teacherText">
                  <p style={{ fontWeight: 600, fontSize: 20 }}>Roxana Lorint</p>
                  <ParagraphStyled>
                    Desarrolladora Frontend en Cognizant
                  </ParagraphStyled>
                  <a
                    href="https://www.linkedin.com/in/roxana-cestari-58341560/"
                    target="_blank"
                  >
                    <LinkedInWrapper>
                      <LinkedInIcon />
                      <ParagraphStyled>
                        /roxana-cestari-58341560/
                      </ParagraphStyled>
                    </LinkedInWrapper>
                  </a>
                </div>
              </TeacherInfo>
              <TeacherInfo>
                <img src="/img/ivan.png" />
                <div className="teacherText">
                  <p style={{ fontWeight: 600, fontSize: 20 }}>Iván Herranz</p>
                  <ParagraphStyled>
                    Desarrollador Frontend en ERNI
                  </ParagraphStyled>
                  <a
                    href="https://www.linkedin.com/in/ivanherranzcuesta/"
                    target="_blank"
                  >
                    <LinkedInWrapper>
                      <LinkedInIcon />
                      <ParagraphStyled>/ivanherranzcuesta</ParagraphStyled>
                    </LinkedInWrapper>
                  </a>
                </div>
              </TeacherInfo>
            </TeacherWrapper>
          </TeachersGrid>
          <CTA style={{ marginTop: "30px" }}>
            <PrimaryButton onClick={() => scrollToSection("register")}>
              Apúntate al webinar
            </PrimaryButton>
          </CTA>
        </Wrapper>
      </GreyBg>
      <Footer />
    </>
  );
};
